import { render, staticRenderFns } from "./ShipReviewOverall.vue?vue&type=template&id=3de5b0f6&"
import script from "./ShipReviewOverall.vue?vue&type=script&lang=js&"
export * from "./ShipReviewOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports